import { Schema } from 'effect';

/** Cart quantities are finite positive integers. */
export const CartQuantity = Schema.Finite.check(
  Schema.isInt(),
  Schema.isGreaterThanOrEqualTo(1)
).pipe(Schema.brand('CartQuantity'));
export type CartQuantity = typeof CartQuantity.Type;

export const decodeCartQuantity = Schema.decodeUnknownOption(CartQuantity);

/** Products without a valid default retain the existing one-piece quantity. */
export const DEFAULT_CART_QUANTITY = Schema.decodeSync(CartQuantity)(1);
